import { FollowRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class UnfollowUserUseCase {
  constructor(private followRepository: FollowRepository) {}

  async execute(followerId: string, followingId: string): Promise<void> {
    logger.debug('UnfollowUser', 'Unfollowing user', { followerId, followingId });

    await this.followRepository.unfollow(followerId, followingId);

    logger.debug('UnfollowUser', 'User unfollowed successfully');
  }
}
